import { useEffect, useRef, useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import { ui } from "../../helpers/ui";

const InitClientRegistrationLogic = () => {
  const navigate = useNavigate();
  const usernameRef = useRef<any>();
  const passwordRef = useRef<any>();
  const firstNameRef = useRef<any>();
  const lastNameRef = useRef<any>();
  const phoneRef = useRef<any>();
  const [data, setData] = useState<any>({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    phone: "",
  });
  const [categories, setCategories] = useState<any[]>([]);
  // Cene kao STRING (polje moze da bude prazno dok se kuca); broj tek na cuvanje.
  const [prices, setPrices] = useState<Record<number, string>>({});

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
          const defaultPrices: Record<number, string> = {};
          for (const cat of response.data) {
            for (const tt of cat.trainingTypes || []) {
              defaultPrices[tt.id] = String(tt.price ?? "");
            }
          }
          setPrices(defaultPrices);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const onSubmit = async () => {
    // Provera obaveznih polja pre potvrde - backend proverava samo prisustvo
    // polja, ne i da nisu prazna
    const required: Array<[string, string]> = [
      ["firstName", "Ime"],
      ["lastName", "Prezime"],
      ["phone", "Telefon"],
      ["username", "Korisničko ime"],
      ["password", "Lozinka"],
    ];
    for (const [field, label] of required) {
      if (!String(data[field] ?? "").trim()) {
        ui.alert(`Popunite polje: ${label}`);
        return;
      }
    }
    // Cena je obavezna za svaki tip treninga (broj >= 0), da se ne upise
    // slucajno prazno/0. Polja su vec pre-popunjena podrazumevanim cenama.
    const numericPrices: Record<number, number> = {};
    for (const cat of categories) {
      for (const tt of cat.trainingTypes || []) {
        const raw = prices[tt.id];
        const num = Number(raw);
        if (raw === undefined || raw === "" || isNaN(num) || num < 0) {
          ui.alert(`Unesite cenu za "${tt.name}".`);
          return;
        }
        numericPrices[tt.id] = num;
      }
    }
    const confirmed = await ui.confirm("Sigurno želite da dodate novog klijenta?");
    if (!confirmed) return;
    clientsApi
      .registerClient({...data, prices: numericPrices})
      .then((response) => {
        if (response.status === 200) {
          ui.toast("Klijent uspešno dodat", "success");
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const onPriceChange = (trainingTypeId: number, value: string) => {
    setPrices({ ...prices, [trainingTypeId]: value });
  };

  return {
    data,
    categories,
    prices,
    usernameRef,
    passwordRef,
    firstNameRef,
    lastNameRef,
    phoneRef,
    onSubmit,
    onChange,
    onPriceChange,
  };
};

export default InitClientRegistrationLogic;
